const DEFAULT_SPORT_ICON = '/photos/icons/sports-icons/sports-icons.png';

const SPORT_ICON_BY_ID: Record<number, string> = {
  13: 'tennis.png',
  2: 'horse-racing.svg',
  8: 'rugby.png',
  9: 'boxing.png',
  12: 'american-football.png',
  14: 'snooker.png',
  15: 'darts.png',
  16: 'baseball.png',
  19: 'rugby.png',
  36: 'aussie-rules.png',
  66: 'bowls.png',
  75: 'gaelic_sports.svg',
  83: 'futsal.png',
  90: 'field-hockey.png',
  92: 'table-tennis.png',
  94: 'badminton.png',
  95: 'beach_voleyball.svg',
  107: 'squash.png',
  110: 'waterpolo.png',
  151: 'e_sports.svg',
  162: 'mma.png',
};

const parseSportId = (sportId?: number | string | null): number | null => {
  if (sportId === null || sportId === undefined) return null;
  const parsed = Number.parseInt(String(sportId), 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getSportIconSrc = (sportId?: number | string | null): string => {
  const parsedId = parseSportId(sportId);
  if (parsedId === null) return DEFAULT_SPORT_ICON;
  const iconName = SPORT_ICON_BY_ID[parsedId] ?? `${parsedId}.png`;
  return `/photos/icons/sports-icons/${iconName}`;
};

export const getDefaultSportIconSrc = (): string => DEFAULT_SPORT_ICON;

const SPORT_SVG_IDS = new Set([
  1, 2, 3, 4, 8, 9, 12, 13, 14, 15, 16, 17, 18, 19, 36, 66, 75, 78, 83, 90, 91,
  92, 94, 95, 107, 110, 151, 162,
]);

/** Alt-theme sport icon. Unlike the UI glyphs these stay colour artwork — the
 *  design mockups show a coloured ball per sport in the rail, and a monochrome
 *  ball reads as a bullet point rather than a sport. */
export const getSportIconSvgSrc = (
  sportId: number | string | null | undefined,
  tone: 'chrome' | 'content'
): string => {
  const parsedId = parseSportId(sportId);
  const suffix = tone === 'chrome' ? '-white' : '';
  const name =
    parsedId !== null && SPORT_SVG_IDS.has(parsedId)
      ? String(parsedId)
      : 'default';
  return `/photos/icons/theme/sports/${name}${suffix}.png`;
};
